/**
 *
 * V 0.1.0
 *
 * */

/* eslint-disable import/prefer-default-export */
export const vehicleSubTableHeaders = [
  {
    text: 'Vehicle Id',
    value: 'ID',
    width: '100%' // fixed: true
  },
  {
    text: 'VIN',
    value: 'VIN',
    width: '100%' // fixed: true
  },
  {
    text: 'Chassis Number',
    value: 'ChassisNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'Special Features',
    value: 'SpecialFeatures',
    width: '100%' // fixed: true
  },
  {
    text: 'Colour',
    value: 'VehicleColour',
    width: '100%' // fixed: true
  },
  {
    text: 'Active',
    value: 'Active',
    width: '100%' // fixed: true
  },
  {
    text: 'Reg',
    value: 'RegNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'StockNumber',
    value: 'StockNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'UserVehicleColour',
    value: 'UserVehicleColour',
    width: '100%' // fixed: true
  },
  {
    text: 'Make',
    value: 'UserVehicleMake',
    width: '100%' // fixed: true
  },
  {
    text: 'Model',
    value: 'UserVehicleModel',
    width: '100%' // fixed: true
  },
  {
    text: 'Colour',
    value: 'Colour',
    width: '100%' // fixed: true
  },
  {
    text: 'Unit ID',
    value: 'UnitID',
    width: '100%' // fixed: true
  },
  {
    text: 'Description',
    value: 'Description',
    width: '100%' // fixed: true
  },
  {
    text: 'MSISDN',
    value: 'MSISDN',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitState',
    value: 'UnitState',
    width: '100%' // fixed: true
  },
  {
    text: 'Client Id',
    value: 'ClientID',
    width: '100%' // fixed: true
  },
  {
    text: 'Inception Date',
    value: 'InceptionDate',
    width: '100%' // fixed: true
  },
  {
    text: 'VehicleMake',
    value: 'VehicleMake',
    width: '100%' // fixed: true
  },
  {
    text: 'VehicleModel',
    value: 'VehicleModel',
    width: '100%' // fixed: true
  },
  {
    text: 'Driver',
    value: 'DriverName',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitModel',
    value: 'UnitModel',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitTypeName',
    value: 'UnitTypeName',
    width: '100%' // fixed: true
  },
  {
    text: 'Firmware',
    value: 'Firmware',
    width: '100%' // fixed: true
  },
  {
    text: 'DEALER',
    value: 'DEALER',
    width: '100%' // fixed: true
  },
  {
    text: 'ClientName',
    value: 'ClientName',
    width: '100%' // fixed: true
  },
  {
    text: 'CompanyName',
    value: 'CompanyName',
    width: '100%' // fixed: true
  },
  {
    text: 'UnitModel2ID',
    value: 'UnitModel2ID',
    width: '100%' // fixed: true
  },
  {
    text: 'LastUpdate',
    value: 'LastUpdate',
    width: '100%' // fixed: true
  },
  {
    text: 'Car Battery',
    value: 'CarBattery',
    width: '100%' // fixed: true
  },
  {
    text: 'Internal Battery',
    value: 'InternalBattery',
    width: '100%' // fixed: true
  },
  {
    text: 'Speed',
    value: 'Speed',
    width: '100%' // fixed: true
  },
  {
    text: 'Latitude',
    value: 'Latitude',
    width: '100%' // fixed: true
  },
  {
    text: 'Longitude',
    value: 'Longitude',
    width: '100%' // fixed: true
  },
  {
    text: 'Ignition Status',
    value: 'IgnitionStatus',
    width: '100%' // fixed: true
  },
  {
    text: 'Tenant Code',
    value: 'TenantCode',
    width: '100%' // fixed: true
  },
  {
    text: 'lcase_RegNumber',
    value: 'lcase_RegNumber',
    width: '100%' // fixed: true
  },
  {
    text: 'lcase_CompanyName',
    value: 'lcase_CompanyName',
    width: '100%' // fixed: true
  },
  {
    text: 'lcase_UnitID',
    value: 'lcase_UnitID',
    width: '100%' // fixed: true
  }
]
